<template>
  <li :class="{ opened: isOpened }">
    <div>
      <h3 @click="isOpened = !isOpened">
        {{ option.question }}
      </h3>
      <p
        v-if="isOpened"
        v-html="option.answer"
      ></p>
    </div>
    <minus-icon
      v-if="isOpened"
      @click="isOpened = !isOpened"
    ></minus-icon>
    <plus-icon
      v-else
      @click="isOpened = !isOpened"
    ></plus-icon>
  </li>
</template>

<script>
import MinusIcon from '~/components/Common/Svg/MinusIcon';
import PlusIcon from '~/components/Common/Svg/PlusIcon';
export default {
  components: {
    PlusIcon,
    MinusIcon,
  },
  props: {
    option: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isOpened: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import './FaqItem.scss';
</style>
